import ecommerce from '../assets/e-commerce.png';
import nasaapi from '../assets/Nasa-API-blog.png'
import rickbot from '../assets/rickchatbot.png'

export const ProjectList = [
    {
        name: "Cyber St0r3",
        image: ecommerce, 
        description: "This is an e-commerce store built using React, Redux, Typescript, GraphQL. It has a user authentification system using Firebase and a payment form that works with Stripe. Images were all generated by me using Midjourney AI.",
        source: "https://github.com/maryambani/e-commerce-web",
        deploy: "https://e-commerce-cyber-store.netlify.app",
        tags: [
            {
                name: "react",
                color: "tag1"
            },
            {
                name: "typescript",
                color: "tag2"
            },
            {
                name: "styled-components",
                color: "tag3"
            },
            {
                name: "firebase",
                color: "tag4"
            },
            {
                name: "stripe",
                color: "tag5"
            },
            {
                name: "graphQL",
                color: "tag6"
            },
            {
                name: "redux",
                color: "tag7"
            },
        ]
        
    },
    {
        name: "Rickbot",
        image: rickbot, 
        description: "Rickbot is a chatbot powered by GPT-3 API to generate responses to user input in the style of Rick Sanchez from Rick and Morty. This was made using React.js.",
        source: "https://github.com/maryambani/rick-and-morty-gpt3",
        deploy: "https://rick-morty-gpt3.netlify.app",
        tags: [
            {
                name: "react",
                color: "tag1"
            },
            {
                name: "javascript",
                color: "tag8"
            },
        ]
    },
    {
        name: "NASA blog",
        image: nasaapi, 
        description: "A generative blog that pulls data from NASA's Astronomy Picture of the Day (APOD) API to dynamically generate blog posts with DOM manipulation. There is also a Favorites feature to save any articles to the local storage.",
        source:"https://github.com/maryambani/nasa-apod",
        deploy: "https://nasa-apod-blog.netlify.app",
        tags: [
            {
                name: "javascript",
                color: "tag8"
            },
            {
                name: "HTML",
                color: "tag9"
            },
            {
                name: "CSS",
                color: "tag10"
            },
        ]
    }
]